var ctNavigationModel;
(function ($) {
 	$.fn.capitechNavigation = function(options) {
		 var options = {};
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			options = { 
				extend: {
					"{root}": function (root) {
						root.theme = ko.computed(function() {
							var theme = getLocalStorage("myCapitechTheme");
							return theme + "Theme";
						});
						root.isCapitechLoginType = ko.computed(function() {
							return getLocalStorage("loginType") !== 'simployerSaam';
						});
						root.bClientSelectionAfterLogin = ko.computed(function() {
							return getLocalStorage("clientSelectionAfterLogin") === true;
						});
						root.clientId = ko.computed(function() {
							return getCookie(CLIENTID_COOKIE_NAME);
						});
						root.clientName = ko.computed(function() {
							return getLocalStorage("clientName");
						}, root);
						root.newClientId = ko.observable(getCookie(CLIENTID_COOKIE_NAME));
						root.openChangeClientModal = function(self) {
							var success = function(data) {
								var modelData = {};
								modelData.authorizedClients = data.content;
								ko.viewmodel.updateFromModel(ctNavigationModel, modelData);
								ctNavigationModel.newClientId(getCookie(CLIENTID_COOKIE_NAME));
								showClientSelector();
							};

							var error = function(data) {
							};

							_api.getAuthorizedCapitechClients_POST(success, error, getCookie(REFRESHTOKEN_COOKIE_NAME));
						},
						root.changeClient = function() {
							var success = function(data) {
								if (data.content && data.content.length > 0) {
									for (var index = 0; index < ctNavigationModel.authorizedClients().length; index++) {
										var authorizedClient = ctNavigationModel.authorizedClients()[index];
										if (ctNavigationModel.newClientId() === authorizedClient.clientId()) {
											setLocalStorage("clientName", authorizedClient.clientName());
										}
										
									}
									persistTokens(data.content[0]);
									setLocalStorage('myCapitechAccessTokenExpires', data.content[0].accessTokenExpires);
									location.reload();
								} else {
									sweetAlert(getResource('app.informationText'), getResource('app.systemErrorMsg'), 'error');
								}
								loaderIndicator(false);
							};

							var error = function(data) {
								loaderIndicator(false);
								sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
							};

							_api.changeClient_POST(success, error, getCookie(REFRESHTOKEN_COOKIE_NAME), ctNavigationModel.newClientId());
							loaderIndicator(true);
						}
					},
					"{root}.navItems[i]": function(navItem){
						navItem.target = ko.computed(function() {
							if (navItem.openInNewWindow() === true) {
								return navItem.linkUrl().replace(/\W/g, '');
							} else {
								return '';
							}
						}, navItem);
					},
					"{root}.authorizedClients[i]": function(authorizedClient) {
					}
				}
			}
			setupNavigation();
		}
		
		function setupNavigation() {
			var modelData = {
				navItems: getLocalStorage('myCapitechExternalLinks'),
				unreadMessageCount: 0,
				permissions: getLocalStorage('myCapitechPermissionsAndRegistrationSetup'),
				newClientId: getCookie(CLIENTID_COOKIE_NAME),
				clientId: getCookie(CLIENTID_COOKIE_NAME),
				authorizedClients: []
			};
			ctNavigationModel = ko.viewmodel.fromModel(modelData, options);
			
			$('*[data-ko-bind="ctNavigationModel"]').each(function(index, obj) {
				ko.applyBindings(ctNavigationModel, obj);
			});

			$('.navigation-inited-opacity-zero').css('opacity', '1');

			if (ctUnreadMessagesModel === undefined) {
				$.fn.capitechUnreadMessages();
				getUnReadMessageCount();
			}

			setInterval(function () {
				getUnReadMessageCount();
			}, 60000);
		}

		function getUnReadMessageCount() {
			ctNavigationModel.unreadMessageCount(getLocalStorage('myCapitechUnReadMessageCount'));
		}

		function showClientSelector() {
			$.magnificPopup.open({
				mainClass: 'dialog-slide-bottom',
				closeOnBgClick: false,
				items: {
					src: $('#ct-change-client'),
					type: 'inline'
				},
				callbacks: {
					open: function() {
						var $thisElm = $(this.container[0]);
						var browserWidth = $(window).width();
						
						initializeComponents($thisElm);
						
						// Translate labels
						translateGUI($thisElm);
						
						// refreshSelect2Elements();
					}
				}
			});
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));